// import React from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { Menu } from "antd";
// import Cookies from "js-cookie";

// const Navbar = () => {
//   const navigate = useNavigate();

//   const handleSchemeClick = (schemeUrl) => {
//     const token = Cookies.get("token");
//     if (!token) {
//       navigate("/login");
//       return;
//     }

//     const redirectUrl = `${schemeUrl}#token=${encodeURIComponent(token)}`;
//     window.location.href = redirectUrl;
//   };

//   const schemeMenu = (
//     <Menu>
//       <Menu.Item key="margin-money">
//         <a
//           href="#"
//           onClick={(e) => {
//             e.preventDefault();
//             handleSchemeClick("http://localhost:3001/money-margin-schemes");
//           }}
//         >
//           Margin Money
//         </a>
//       </Menu.Item>
//       <Menu.Item key="direct-finance">
//         <a
//           href="#"
//           onClick={(e) => {
//             e.preventDefault();
//             handleSchemeClick("http://localhost:3001/direct-finance-schemes");
//           }}
//         >
//           Direct Finance
//         </a>
//       </Menu.Item>
//     </Menu>
//   );

//   return (
//     <Menu mode="horizontal" theme="dark">
//       <Menu.Item key="home">
//         <Link to="/">Home</Link>
//       </Menu.Item>
//       <Menu.Item key="about">
//         <Link to="/about">About Us</Link>
//       </Menu.Item>
//       <Menu.SubMenu key="schemes" title="Schemes">
//         {schemeMenu.props.children}
//       </Menu.SubMenu>
//       <Menu.Item key="contact">
//         <Link to="/contact">Contact Us</Link>
//       </Menu.Item>
//       <Menu.Item key="register">
//         <Link to="/register">Register</Link>
//       </Menu.Item>
//       <Menu.Item key="login">
//         <Link to="/login">Login</Link>
//       </Menu.Item>
//     </Menu>
//   );
// };

// export default Navbar;

import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { Menu, Button, Row, Col } from "antd";
import Cookies from "js-cookie";
import GOVLOGO from "../Images/GOVLOGO.png"
import MPBCDCLOGO from "../Images/MPBCDCLOGO.png"
import GhatikCorp from "../Images/GhatikCorp.svg"
import Login from '../components/pages/Login'; // Adjust the path based on where Login.js is located



const Navbar = () => {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [username, setUsername] = useState('');

  useEffect(() => {
    const storedUsername = localStorage.getItem('username');
    if (storedUsername) {
      setIsLoggedIn(true);
      setUsername(storedUsername);
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('username');
    setIsLoggedIn(false);
    setUsername('');
  };

  const handleLogin = (username) => {
    setIsLoggedIn(true);
    setUsername(username);
  };

  const handleSchemeClick = (schemeUrl) => {
    const token = Cookies.get("token");
    if (!token) {
      navigate("/login");
      return;
    }

    const redirectUrl = `${schemeUrl}#token=${encodeURIComponent(token)}`;
    window.location.href = redirectUrl;
  };

  const schemeMenu = (
    <Menu>
      <Menu.Item key="margin-money">
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            handleSchemeClick("/margin-money-scheme");
          }}
        >
          Margin Money
        </a>
      </Menu.Item>
      <Menu.Item key="direct-finance">
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            handleSchemeClick("/direct-finance-scheme");
          }}
        >
          Direct Finance
        </a>
      </Menu.Item>
    </Menu>
  );;

  return (
    <div
      style={{
        backgroundColor: "#fff",
        borderBottom: "1px solid #e8e8e8",
        padding: "10px 20px",
      }}
    >
      <Row align="middle" justify="space-between">
        {/* Left Section: Logos and Title */}
        <Col>
          <div style={{ display: "flex", alignItems: "center" }}>
            {/* Placeholder for logos - replace with actual image sources */}
            <img
              src={GOVLOGO}
              alt="Logo 1"
              style={{ height: "40px", marginRight: "10px" }}
            />
            <img
              src={MPBCDCLOGO}
              alt="Logo 2"
              style={{ height: "40px", marginRight: "10px" }}
            />
            <img
              src={GhatikCorp}
              alt="Logo 3"
              style={{ height: "45px", width: "320px", marginLeft:"-50px",marginRight: "10px" }}
            />

            {/* <div style={{ width:"200px", height:"30px",textAlign:"left",marginTop:"-25px"}}>
              <h2 style={{ margin: 0, fontSize: "12px", color: "#000",fontWeight:"bold" }}>
                HINDU KHATIK SAMAJ ECONOMIC<br/> DEVELOPMENT CORPORATION
              </h2>
              <p style={{ margin: 0, fontSize: "8px", color: "#555",}}>
              Subsidiary of MPBCDC, Mumbai.<br/>
              Social Justice & Special Assistance Govt of Maharashtra.  
              </p>
            </div> */}
          </div>
        </Col>

        {/* Center Section: Menu Items */}
        <Col>
        <Menu
          mode="horizontal"
          theme="light"
          style={{
            width:"100%",
            borderBottom: "none",
            fontWeight:'Bold',
            marginRight:"90px",
            display: "flex",
            justifyContent: "center",
            background: "transparent",
            overflow: "visible", // add this line
            flexWrap: "nowrap",  // optional: prevents wrapping
          }}
        >

            <Menu.Item key="home">
              <Link to="/">HOME</Link>
            </Menu.Item>
            <Menu.Item key="about">
              <Link to="/about">ABOUT US</Link>
            </Menu.Item>
            <Menu.SubMenu key="schemes" title="SCHEMES">
              {schemeMenu.props.children}
            </Menu.SubMenu>
            <Menu.Item key="contact">
              <Link to="/contact">CONTACT US</Link>
            </Menu.Item>
          </Menu>
        </Col>

        {/* Right Section: Login/Register Button */}
        <Col>
        {isLoggedIn ? (
        <>
          <span>Welcome, {username}</span>
          <Button onClick={handleLogout}>Logout</Button>
        </>
      ) : (
        <Button
          type="primary"
          shape="round"
          size="small"  // <-- add this
          style={{
            backgroundColor: "#193367",
            width:"215px",
            height:"40px",
            color: "#fff",
            fontWeight:"bold",
          }}
          onClick={() => navigate("/login")}
        >
          Login / Register
        </Button>
         )}

        </Col>
      </Row>
    </div>
  );
};

export default Navbar;